// extracted by mini-css-extract-plugin
module.exports = {"SideBarToggle":"HamBurgermenu_SideBarToggle__3naxh"};